//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "houseCard",
    data() {
        return {
            value: '',
            show: false,
            showPicker: false,
            list: [],
            loading: false,
            finished: false,
            owner: {},
            // projectId: 0
        }
    },
    methods: {
        onLoad() {
        },
        showPopup() {
            this.show = true;
        },
        certificate() {
            this.$router.push({path: '/certificate'})
        },
        onConfirm(value) {
            this.value = value;
            console.log(value)
            this.showPicker = false;
        },
        getOwnerById() {
            const vm = this;
            abp.ajax.get('/api/services/app/NewOwner/GetOwnerById?id=' + this.id).then(res => {
                vm.owner = {};
                vm.owner = res.data.result;
                // vm.getProject(vm.owner.projectId);
                vm.getContents(vm.owner.cityName);
            });
        },
        getContents(city) {
            abp.ajax.get('/api/services/app/Content/GetContentByNodeName?name=房产政策&city=' + city).then(res => {
                this.list = [];
                this.list.push(...res.data.result);
            }).finally(() => {
                this.finished = true;
            });
        },
        // getProject(projectId) {
        //     this.$store.dispatch({
        //         type: 'project/GetProjectById',
        //         id: projectId
        //     }).then(() => {
        //         let project = this.$store.state.project.projectInfo;
        //         this.getContents(project.cityName);
        //     })
        // },


    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getOwnerById();
        }
        // this.projectId = parseInt(localStorage.getItem('Select-ProjectId')) || 0;
        // if (this.projectId > 0) {
        //     this.getProject();
        // }
    }
}
